import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-accounts.manage', {
        url: '/manage/:username',
        views: {
            '@company': 'companySharingCenterSharedAccountsManage'
        },
        resolve: {
            $breadcrumbs,
            applicationGroups,
            customGroups,
            sharedAccounts,
            username,
        },
    });
}

/** @ngInject */
function $breadcrumbs(username) {
    return [{title: username}];
}

/** @ngInject */
function applicationGroups(companyId, Groups) {
    return Groups.getGroupsByType({companyId, type: 'APPLICATION'}).$promise;
}

/** @ngInject */
function customGroups(companyId, Groups) {
    return Groups.getGroupsByType({companyId, type: 'CUSTOM'}).$promise;
}

/** @ngInject */
function sharedAccounts($state, companyId, UserAccounts, username) {
    return UserAccounts
        .getSharedEmailAccountsByUsername({companyId, username}).$promise
        .then((accounts) => {
            if (!accounts.length) {
                $state.go('company.sharing-center.shared-accounts');
            }
            return accounts;
        });
}

/** @ngInject */
function username($stateParams) {
    return $stateParams.username;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-company-account/shared-company-account.state.js